<template>
    <div id="kt_app_footer" class="app-footer ">
        <div
            class="app-container  container-fluid d-flex flex-column flex-md-row flex-center flex-md-stack py-3 ">
            <div class="text-dark order-2 order-md-1">
                <span class="text-muted fw-semibold me-1">{{ currentYear() }} &copy;</span>
                <a href="#" target="_blank" class="text-gray-800 text-hover-primary">KOBOEAT</a>
            </div>

            <ul class="menu menu-gray-600 menu-hover-primary fw-semibold order-1">
                <!-- <li class="menu-item"><a href="https://keenthemes.com" target="_blank" class="menu-link px-2">About</a>
                </li>

                <li class="menu-item"><a href="https://devs.keenthemes.com" target="_blank" class="menu-link px-2">Support</a>
                </li>

                <li class="menu-item"><a href="https://1.envato.market/EA4JP" target="_blank" class="menu-link px-2">Purchase</a>
                </li> -->
            </ul>
        </div>
    </div>
</template>

<script setup>
    function currentYear() {
        return new Date().getFullYear() 
    }
</script>

<style scoped>
  #kt_app_footer{
    position: fixed;
    bottom: 0;
  }

  @media (max-width: 992px){
    #kt_app_footer{
      width: 100vw;
    }
  }

  @media (min-width: 992px){
    [data-kt-app-sidebar-minimize=on] #kt_app_footer{
      width: calc(100vw - 75px);
    }
  }

  @media (min-width: 992px){
    #kt_app_footer{
      width: calc(100vw - 265px);
    }
  }
</style>